const pad = (num: any, size: number) => {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
};

export default pad;
